var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { attachBandYHover, attachPolarSliceHover, attachValueHover } from '../core/interaction';
import { registerDashboard } from '../../registryCore';
import { createWidgetGroup, clamp, num, setState } from '../../helpers';
import { getActiveDashboard } from '../../theme';
import { createPieWidget, buildRadarChart } from './polarBase';
registerDashboard('pieChart', function (props, app) { return createPieWidget(app, 'pieChart', props, 0); });
registerDashboard('doughnutChart', function (props, app) { return createPieWidget(app, 'doughnutChart', props); });
registerDashboard('radarChart', function (props, app) {
    var group = createWidgetGroup(app, 'radarChart', props);
    buildRadarChart(group, app, props);
    return group;
});
registerDashboard('spiderChart', function (props, app) {
    var group = createWidgetGroup(app, 'spiderChart', props);
    buildRadarChart(group, app, props);
    return group;
});
registerDashboard('polarAreaChart', function (props, app) {
    var _a;
    var size = num(props, 'size', 200);
    var data = (_a = props.data) !== null && _a !== void 0 ? _a : [3, 5, 4, 6, 2];
    var group = createWidgetGroup(app, 'polarAreaChart', props);
    var cx = size / 2;
    var max = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(data), false), [1], false));
    var n = data.length;
    var start = -Math.PI / 2;
    data.forEach(function (v, i) {
        var sweep = (Math.PI * 2) / n;
        var r = (v / max) * (size / 2 - 16);
        var end = start + sweep;
        group.add(app.arc({
            x: cx - r,
            y: cx - r,
            radius: r,
            startAngle: start,
            endAngle: end,
            fill: getActiveDashboard().series[i % getActiveDashboard().series.length],
            stroke: getActiveDashboard().pieStroke,
            strokeWidth: 1,
            listening: false,
        }));
        start = end;
    });
    attachPolarSliceHover(app, group, props, size, data, data.map(function (v, i) { return "Cat ".concat(i + 1, ": ").concat(v); }));
    setState(group, { size: size, data: data });
    return group;
});
registerDashboard('bulletChart', function (props, app) {
    var width = num(props, 'width', 260);
    var height = num(props, 'height', 48);
    var value = clamp(num(props, 'value', 65), 0, 100);
    var target = num(props, 'target', 80);
    var max = num(props, 'max', 100);
    var group = createWidgetGroup(app, 'bulletChart', props);
    group.add(app.rect({ width: width, height: height * 0.5, y: height * 0.25, fill: getActiveDashboard().meterTrack, listening: false }));
    group.add(app.rect({
        x: 0,
        y: height * 0.25,
        width: (width * value) / max,
        height: height * 0.5,
        fill: getActiveDashboard().primary,
        listening: false,
    }));
    var tx = (width * target) / max;
    group.add(app.line({
        x: tx,
        y: height * 0.15,
        x2: 0,
        y2: height * 0.7,
        stroke: getActiveDashboard().danger,
        strokeWidth: 3,
        listening: false,
    }));
    attachValueHover(app, group, props, width, height, "Value: ".concat(value, " / Target: ").concat(target));
    setState(group, { width: width, height: height, value: value, target: target, max: max });
    return group;
});
registerDashboard('funnelChart', function (props, app) {
    var _a;
    var width = num(props, 'width', 200);
    var height = num(props, 'height', 220);
    var data = (_a = props.data) !== null && _a !== void 0 ? _a : [100, 72, 48, 28, 12];
    var group = createWidgetGroup(app, 'funnelChart', props);
    var max = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(data), false), [1], false));
    var step = height / data.length;
    data.forEach(function (v, i) {
        var w = (v / max) * width;
        var x = (width - w) / 2;
        group.add(app.polygon({
            points: [x, i * step, x + w, i * step, x + w * 0.92, (i + 1) * step, x + w * 0.08, (i + 1) * step],
            fill: getActiveDashboard().series[i % getActiveDashboard().series.length],
            stroke: getActiveDashboard().pieStroke,
            strokeWidth: 1,
            listening: false,
        }), app.text({
            text: String(v),
            x: width / 2 - 12,
            y: i * step + step / 2 - 6,
            fontSize: 11,
            fill: getActiveDashboard().text,
            listening: false,
        }));
    });
    attachBandYHover(app, group, props, width, height, data.length, function (i) { return String(data[i]); });
    setState(group, { width: width, height: height, data: data });
    return group;
});
registerDashboard('pyramidChart', function (props, app) {
    var _a;
    var width = num(props, 'width', 200);
    var height = num(props, 'height', 200);
    var data = (_a = props.data) !== null && _a !== void 0 ? _a : [10, 20, 35, 55, 80];
    var group = createWidgetGroup(app, 'pyramidChart', props);
    var max = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(data), false), [1], false));
    var step = height / data.length;
    data.forEach(function (v, i) {
        var w = (v / max) * width;
        var x = (width - w) / 2;
        group.add(app.rect({
            x: x,
            y: i * step,
            width: w,
            height: step - 2,
            fill: getActiveDashboard().series[i % getActiveDashboard().series.length],
            listening: false,
        }));
    });
    attachBandYHover(app, group, props, width, height, data.length, function (i) { return String(data[i]); });
    setState(group, { width: width, height: height, data: data });
    return group;
});
registerDashboard('coneChart', function (props, app) {
    var width = num(props, 'width', 160);
    var height = num(props, 'height', 200);
    var group = createWidgetGroup(app, 'coneChart', props);
    group.add(app.polygon({
        points: [width / 2, 0, width, height, 0, height],
        fill: getActiveDashboard().primary,
        stroke: getActiveDashboard().panelStroke,
        strokeWidth: 1,
        listening: false,
    }));
    attachValueHover(app, group, props, width, height, 'Cone chart');
    setState(group, { width: width, height: height });
    return group;
});
